import store from '@state/store'

const authRoutes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@views/pages/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['users/get_loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@views/pages/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['users/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
        import('@views/pages/account/forgetPassword'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['users/get_loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('sessions/FETCH_SESSIONS_DELETE');
        window.location.href = "/";
      },
    },
  },
]

const accountRoutes = [
  {
    path: '/account',
    header: 'Аккаунт',
    icon: 'home',
    props: (route) => ({ user: store.state.users.USER_ITEM || {} }),
    meta: { authRequired: true, adminRequired: false },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [

      {
        path: '/',
        name: 'Account',
        // title: 'Дашборд',
        // component: () => import('@views/pages/dashboard/index'),
        title: 'Продажи',
        component: () => import('@views/pages/sales/index'),
      },

      {
        path: 'dashboard',
        name: 'Dashboard',
        title: 'Дашборд',
        component: () => import('@views/pages/dashboard/index'),
      },

      {
        path: 'profile',
        name: 'Profile',
        title: 'Профиль пользователя',
        component: () => import('@views/pages/profile/form'),
      },

      {
        path: 'settings',
        name: 'Settings',
        title: 'Настройки',
        component: () => import('@views/pages/settings/form'),
      },

      {
        path: 'finance',
        name: 'Finance',
        title: 'Движение денежных средств',
        component: () => import('@views/pages/finance/index'),
      },
      {
        path: 'finance/create',
        name: 'Finance.create',
        title: 'Новая операция',
        component: () => import('@views/pages/finance/form'),
      },
      {
        path: 'finance/:type',
        name: 'Finance',
        title: 'Финансовые операции',
        component: () => import('@views/pages/finance/index'),
      },
      {
        path: 'finance/:finance_uuid/edit',
        name: 'Finance.edit',
        title: 'Редактирование операции',
        component: () => import('@views/pages/finance/form'),
      },

      // orders
      {
        path: 'orders',
        name: 'Orders',
        title: 'Заказы',
        component: () => import('@views/pages/orders/index'),
      },
      {
        path: 'orders/create',
        name: 'Orders.create',
        title: 'Новый заказ',
        component: () => import('@views/pages/orders/form'),
      },
      {
        path: 'orders/:uuid/edit',
        name: 'Orders.edit',
        title: 'Редактирование заказа',
        component: () => import('@views/pages/orders/form'),
      },

      // sales
      {
        path: 'sales',
        name: 'Sales',
        title: 'Продажи',
        component: () => import('@views/pages/sales/index'),
      },
      {
        path: 'sales/create',
        name: 'Sales.create',
        title: 'Новая продажа',
        component: () => import('@views/pages/sales/form'),
      },
      {
        path: 'sales/:uuid/edit',
        name: 'Sales.edit',
        title: 'Редактирование продажи',
        component: () => import('@views/pages/sales/form'),
      },

      // planned
      {
        path: 'planned',
        name: 'Planned',
        title: 'Планирование',
        component: () => import('@views/pages/planned/index'),
      },
      {
        path: 'planned/create',
        name: 'Planned.create',
        title: 'Новый план',
        component: () => import('@views/pages/planned/form'),
      },
      {
        path: 'planned/:uuid/edit',
        name: 'Planned.edit',
        title: 'Редактирование плана',
        component: () => import('@views/pages/planned/form'),
      },

      // counterparties
      {
        path: 'counterparties',
        name: 'Counterparties',
        title: 'Контрагенты',
        component: () => import('@views/pages/counterparties/index'),
      },
      {
        path: 'counterparties/create',
        name: 'Counterparties.create',
        title: 'Новый контрагент',
        component: () => import('@views/pages/counterparties/form'),
      },
      {
        path: 'counterparties/:uuid/edit',
        name: 'Counterparties.edit',
        title: 'Редактирование контрагента',
        component: () => import('@views/pages/counterparties/form'),
      },

      // products
      {
        path: 'products',
        name: 'Products',
        title: 'Товары',
        component: () => import('@views/pages/products/index'),
      },
      {
        path: 'products/create',
        name: 'Products.create',
        title: 'Новая позиция',
        component: () => import('@views/pages/products/form'),
      },
      {
        path: 'products/:uuid/edit',
        name: 'Products.edit',
        title: 'Редактирование позиции',
        component: () => import('@views/pages/products/form'),
      },

      // products_categories
      {
        path: 'products/categories',
        name: 'Products.Categories',
        title: 'Категории товаров',
        component: () => import('@views/pages/products/categories/index'),
      },
      {
        path: 'products/categories/create',
        name: 'Products.Categories.create',
        title: 'Новая категория товаров',
        component: () => import('@views/pages/products/categories/form'),
      },
      {
        path: 'products/categories/:uuid/edit',
        name: 'Products.Categories.edit',
        title: 'Редактирование категории',
        component: () => import('@views/pages/products/categories/form'),
      },

      // assortments
      {
        path: 'assortments',
        name: 'Assortments',
        title: 'Ассортимент',
        component: () => import('@views/pages/assortments/index'),
      },
      {
        path: 'assortments/create',
        name: 'Assortments.create',
        title: 'Новая позиция',
        component: () => import('@views/pages/assortments/form'),
      },
      {
        path: 'assortments/:uuid/edit',
        name: 'Assortments.edit',
        title: 'Редактирование позиции',
        component: () => import('@views/pages/assortments/form'),
      },

      // costs
      {
        path: 'costs',
        name: 'Costs',
        title: 'Затраты',
        component: () => import('@views/pages/costs/index'),
      },
      {
        path: 'costs/create',
        name: 'Costs.create',
        title: 'Новая операция',
        component: () => import('@views/pages/costs/form'),
      },
      {
        path: 'costs/:uuid/edit',
        name: 'Costs.edit',
        title: 'Редактирование операции',
        component: () => import('@views/pages/costs/form'),
      },

      // brands
      {
        path: 'brands',
        name: 'Brands',
        title: 'Бренды',
        component: () => import('@views/pages/brands/index'),
      },
      {
        path: 'brands/create',
        name: 'Brands.create',
        title: 'Новый бренд',
        component: () => import('@views/pages/brands/form'),
      },
      {
        path: 'brands/:uuid/edit',
        name: 'Brands.edit',
        title: 'Редактирование бренда',
        component: () => import('@views/pages/brands/form'),
      },

      // costs_items
      {
        path: 'costs/items',
        name: 'Costs.Items',
        title: 'Статьи затрат',
        component: () => import('@views/pages/costs/items/index'),
      },
      {
        path: 'costs/items/create',
        name: 'Costs.Items.create',
        title: 'Новая статья затрат',
        component: () => import('@views/pages/costs/items/form'),
      },
      {
        path: 'costs/items/:uuid/edit',
        name: 'Costs.Items.edit',
        title: 'Редактирование статьи затрат',
        component: () => import('@views/pages/costs/items/form'),
      },

      // planned_indicators
      {
        path: 'planned/indicators',
        name: 'Planned.Indicators',
        title: 'Плановые показатели',
        component: () => import('@views/pages/planned/indicators/index'),
      },
      {
        path: 'planned/indicators/create',
        name: 'Planned.Indicators.create',
        title: 'Новый показатель',
        component: () => import('@views/pages/planned/indicators/form'),
      },
      {
        path: 'planned/indicators/:uuid/edit',
        name: 'Planned.Indicators.edit',
        title: 'Редактирование показателя',
        component: () => import('@views/pages/planned/indicators/form'),
      },

      // companies
      {
        path: 'companies',
        name: 'Companies',
        title: 'Компании',
        component: () => import('@views/pages/companies/index'),
      },
      {
        path: 'companies/create',
        name: 'Companies.create',
        title: 'Новая компания',
        component: () => import('@views/pages/companies/form'),
      },
      {
        path: 'companies/:uuid/edit',
        name: 'Companies.edit',
        title: 'Редактирование компании',
        component: () => import('@views/pages/companies/form'),
      },

      // bank_accounts
      {
        path: 'bank/accounts',
        name: 'Bank.Accounts',
        title: 'Банковские счета',
        component: () => import('@views/pages/bank/accounts/index'),
      },
      {
        path: 'bank/accounts/create',
        name: 'Bank.Accounts.create',
        title: 'Новый счет',
        component: () => import('@views/pages/bank/accounts/form'),
      },
      {
        path: 'bank/accounts/:uuid/edit',
        name: 'Bank.Accounts.edit',
        title: 'Редактирование счета',
        component: () => import('@views/pages/bank/accounts/form'),
      },

      // marketplaces
      {
        path: 'marketplaces',
        name: 'Marketplaces',
        title: 'Маркетплейсы',
        component: () => import('@views/pages/marketplaces/index'),
      },
      {
        path: 'marketplaces/create',
        name: 'Marketplaces.create',
        title: 'Новый маркетплейс',
        component: () => import('@views/pages/marketplaces/form'),
      },
      {
        path: 'marketplaces/:uuid/edit',
        name: 'Marketplaces.edit',
        title: 'Редактирование маркетплейса',
        component: () => import('@views/pages/marketplaces/form'),
      },

      // shops
      {
        path: 'shops',
        name: 'Shops',
        title: 'Магазины',
        component: () => import('@views/pages/shops/index'),
      },
      {
        path: 'shops/create',
        name: 'Shops.create',
        title: 'Новый магазин',
        component: () => import('@views/pages/shops/form'),
      },
      {
        path: 'shops/:uuid/edit',
        name: 'Shops.edit',
        title: 'Редактирование магазина',
        component: () => import('@views/pages/shops/form'),
      },

      // reports
      {
        path: 'reports/orders',
        name: 'Reports.Orders',
        title: 'Заказы',
        component: () => import('@views/pages/reports/orders/index'),
      },
      {
        path: 'reports/warehouses',
        name: 'Reports.Warehouses',
        title: 'Склад',
        component: () => import('@views/pages/reports/warehouses/index'),
      },      

      // purchases
      {
        path: 'purchases',
        name: 'Purchases',
        title: '',
        component: () => import('@views/pages/purchases/index'),
      },
      {
        path: 'purchases/create',
        name: 'Purchases.create',
        title: '',
        component: () => import('@views/pages/purchases/form'),
      },
      {
        path: 'purchases/:uuid/edit',
        name: 'Purchases.edit',
        title: '',
        component: () => import('@views/pages/purchases/form'),
      },

      // warehouses
      {
        path: 'warehouses',
        name: 'Warehouses',
        title: '',
        component: () => import('@views/pages/warehouses/index'),
      },
      {
        path: 'warehouses/create',
        name: 'Warehouses.create',
        title: '',
        component: () => import('@views/pages/warehouses/form'),
      },
      {
        path: 'warehouses/:uuid/edit',
        name: 'Warehouses.edit',
        title: '',
        component: () => import('@views/pages/warehouses/form'),
      },

      // movings
      {
        path: 'movings',
        name: 'Movings',
        title: '',
        component: () => import('@views/pages/movings/index'),
      },
      {
        path: 'movings/create',
        name: 'Movings.create',
        title: '',
        component: () => import('@views/pages/movings/form'),
      },
      {
        path: 'movings/:uuid/edit',
        name: 'Movings.edit',
        title: '',
        component: () => import('@views/pages/movings/form'),
      },

      // integrations
      {
        path: 'integrations',
        name: 'Integrations',
        title: 'Интеграции',
        component: () => import('@views/pages/integrations/index'),
      },
      {
        path: 'integrations/create',
        name: 'Integrations.create',
        title: 'Новая интеграция',
        component: () => import('@views/pages/integrations/form'),
      },
      {
        path: 'integrations/:integration_uuid/edit',
        name: 'Integrations.edit',
        title: 'Редактирование интеграции',
        component: () => import('@views/pages/integrations/form'),
      },

    ],
  },
]

const adminRoutes = [
  {
    path: '/account',
    header: 'Аккаунт',
    icon: 'home',
    props: (route) => ({user: store.state.users.USER_ITEM || {}}),
    meta: {authRequired: true, adminRequired: true},
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'users/accounts',
        name: 'Users.Accounts',
        title: 'Аккаунты',
        component: () => import('@views/pages/accounts/index'),
      },
      {
        path: 'users/accounts/create',
        name: 'Users.Accounts.create',
        title: 'Новый аккаунт',
        component: () => import('@views/pages/accounts/form'),
      },
      {
        path: 'users/accounts/:account_uuid/edit',
        name: 'Users.Accounts.edit',
        title: 'Редактирование аккаунта',
        component: () => import('@views/pages/accounts/form'),
      },
      {
        path: 'users',
        name: 'Users',
        title: 'Пользователи',
        component: () => import('@views/pages/users/index'),
      },
      {
        path: 'users/create',
        name: 'Users.create',
        title: 'Новый пользователь',
        component: () => import('@views/pages/users/form'),
      },
      {
        path: 'users/:user_uuid/edit',
        name: 'Users.edit',
        title: 'Редактирование информации о пользователе',
        component: () => import('@views/pages/users/form'),
      },
      {
        path: 'currency',
        name: 'Currency',
        title: 'Валюты',
        component: () => import('@views/pages/currency/index'),
      },
      {
        path: 'currency/create',
        name: 'Currency.create',
        title: 'Новая валюта',
        component: () => import('@views/pages/currency/form'),
      },
      {
        path: 'currency/:currency_uuid/edit',
        name: 'Currency.edit',
        title: 'Редактирование валюты',
        component: () => import('@views/pages/currency/form'),
      },
      
      {
        path: 'finance/types',
        name: 'Finance.Types',
        title: 'Категории операций',
        component: () => import('@views/pages/finance/types/index'),
      },
      {
        path: 'finance/types/create',
        name: 'Finance.Types.create',
        title: 'Новая категория',
        component: () => import('@views/pages/finance/types/form'),
      },
      {
        path: 'finance/types/:finance_type_uuid/edit',
        name: 'Finance.Types.edit',
        title: 'Редактирование категории',
        component: () => import('@views/pages/finance/types/form'),
      },
      
      // countries
      {
        path: 'countries',
        name: 'Countries',
        title: 'Страны',
        component: () => import('@views/pages/countries/index'),
      },
      {
        path: 'countries/create',
        name: 'Countries.create',
        title: 'Новая страна',
        component: () => import('@views/pages/countries/form'),
      },
      {
        path: 'countries/:uuid/edit',
        name: 'Countries.edit',
        title: 'Редактирование страны',
        component: () => import('@views/pages/countries/form'),
      },

      // units
      {
        path: 'units',
        name: 'Units',
        title: '',
        component: () => import('@views/pages/units/index'),
      },
      {
        path: 'units/create',
        name: 'Units.create',
        title: '',
        component: () => import('@views/pages/units/form'),
      },
      {
        path: 'units/:uuid/edit',
        name: 'Units.edit',
        title: '',
        component: () => import('@views/pages/units/form'),
      },

    ]
  }
]

const authProtectedRoutes = [
  ...adminRoutes,
  ...accountRoutes
]

const allRoutes = [
  ...authRoutes,
  ...authProtectedRoutes,
]

export {
  allRoutes,
  authProtectedRoutes
}